import React from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSwitcher.css';

const LanguageSwitcher = ({ isMobile = false }) => {
  const { i18n, t } = useTranslation();
  const currentLang = i18n.language;

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem('language', lang);
  };

  if (isMobile) {
    // Mobile version with flag emojis
    return (
      <div className="language-switcher mobile">
        <button
          onClick={() => changeLanguage('en')}
          className={currentLang === 'en' ? 'active' : ''}
          aria-label={t('accessibility.changeLanguage')}
          aria-current={currentLang === 'en' ? 'true' : 'false'}
        >
          🇺🇸
        </button>
        <span className="divider">|</span>
        <button
          onClick={() => changeLanguage('ko')}
          className={currentLang === 'ko' ? 'active' : ''}
          aria-label={t('accessibility.changeLanguage')}
          aria-current={currentLang === 'ko' ? 'true' : 'false'}
        >
          🇰🇷
        </button>
      </div>
    );
  }

  // Desktop version with text
  return (
    <div className="language-switcher desktop">
      <button
        onClick={() => changeLanguage('en')}
        className={currentLang === 'en' ? 'active' : ''}
        aria-label={t('accessibility.changeLanguage')}
        aria-current={currentLang === 'en' ? 'true' : 'false'}
      >
        EN
      </button>
      <span className="divider">|</span>
      <button
        onClick={() => changeLanguage('ko')}
        className={currentLang === 'ko' ? 'active' : ''}
        aria-label={t('accessibility.changeLanguage')}
        aria-current={currentLang === 'ko' ? 'true' : 'false'}
      >
        KO
      </button>
    </div>
  );
};

export default LanguageSwitcher;
